import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type UserProjectSessionPermissionCodes = 'CANCEL';

export default getPermissionsHook<
  UserProjectSessionPermissionCodes,
  {
    userId: number;
    projectSessionId: number;
  }
>({
  entityName: 'userJurySessionPermissions',
  fetch: ({ userId, projectSessionId }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .projectSessions.id(projectSessionId)
      .permissions.find(),
});
